import { CustomError } from "@/utils/errors";

import { datadogRum } from "@datadog/browser-rum";

type TrackableContext = Record<
  string,
  string | number | undefined | CustomError
>;

/**
 * Hook for tracking user interactions and errors with Datadog RUM
 *
 * @returns Object with tracking functions for both actions and errors
 */
export const useDatadogAnalytics = () => {
  /**
   * Tracks user actions/events in the application
   *
   * @param name - Action name (use snake_case for consistency)
   * @param context - Additional properties to include with the action
   */
  const trackAction = (name: string, context: TrackableContext = {}) => {
    const { error } = context;
    datadogRum.addAction(name, {
      status: error === undefined ? "success" : "error",
      error,
      ...context
    });
  };

  return { trackAction };
};
